import { Empty } from 'antd';
import RawMessage from './RawMessage';

/** Last-resort renderer for a notification no system-specific component handles. */
const RawData = (props: { notification?: { messageType?: string } | null; rawMessage?: string }) => {
    if (!props.notification && !props.rawMessage) {
        return <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} description="There are no messages for this declaration." />;
    }

    return (
        <div>
            <span>Notification: {props.notification?.messageType}</span>
            <RawMessage>{props.rawMessage || JSON.stringify(props.notification, null, 2)}</RawMessage>
        </div>
    );
};

export default RawData;
